import { purchaseOrderCategories } from "@/api/purchaseOrderCategories/usePurchaseOrderCategoriesQuery";
import { PurchaseOrderCategoryDetailHeader } from "@/features/purchaseOrderCategory/header/DetailHeader";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { Main } from "@/features/standard/Main";
import { useQuery } from "@tanstack/react-query";

const Detail = Object.assign(Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
});

interface PurchaseOrderCategoryDetailFormProps {
  PurchaseOrderCategoryName: string | undefined;
}

export const PurchaseOrderCategoryDetailForm = (params: PurchaseOrderCategoryDetailFormProps) => {
  const { PurchaseOrderCategoryName } = params;

  const { data: itemCategory } = useQuery(
    purchaseOrderCategories.get({
      query: { $and: [{ name: { $eq: PurchaseOrderCategoryName } }] },
    }),
  );

  return (
    <>
      <Detail.Container>
        <Detail.Wrapper>
          <Detail.Content>
            <PurchaseOrderCategoryDetailHeader data={itemCategory} />
          </Detail.Content>
        </Detail.Wrapper>
      </Detail.Container>
    </>
  );
};
